var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-devices"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"device"},[_vm._v("\n      Desktop\n    ")])])])}]

export { render, staticRenderFns }